// The provider concatenates the broker document ID into the outbound URL path,
// so the backend constrains it to an alphanumeric-and-dash token. Mirrored here
// to fail on the field rather than on a 422, and tightened to reject leading,
// trailing and repeated dashes, which the backend rule allows but no
// provider-issued ID uses.
export const BROKER_DOCUMENT_ID_PATTERN = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;

export const BROKER_DOCUMENT_ID_ERROR =
  'Broker Document ID can only contain letters, numbers and single dashes';
